import * as React from 'react';
import { JRCFormSelectTagField } from '../JRCFormSelect/JRCFormSelectTag';
import jamespot, { AudienceAutocomplete } from 'jamespot-user-api';
import { JRCFormSelectProps } from '../JRCFormSelect/JRCFormSelect';

export interface JRCAutocompleteAudienceProps extends JRCFormSelectProps<any> {
    onlyUser: boolean;
    isMulti?: boolean;
}

/**
 * @deprecated use JRCInputAutocomplete and its variants instead
 */
const autocompleteAudience = (inputValue: string) =>
    jamespot.audience.autocomplete(inputValue).then((res) => {
        // converting flat structure dataset to a sectionName-values structure for 2 level rendering
        const options = res.reduce((acc: Map<string, AudienceAutocomplete[]>, jAudience: AudienceAutocomplete) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (acc.get(jAudience.label)) acc.set(jAudience.label, [...acc.get(jAudience.label), jAudience]);
            else acc.set(jAudience.label, [jAudience]);
            return acc;
        }, new Map());
        return Array.from(options.entries()).map(([k, v]) => ({ label: k, options: v }));
    });

const autocompleteUser = (inputValue: string) => jamespot.user.autocomplete(inputValue);

/**
 * Component audience that returns users or audience-like entries according to the user input
 * @param props JRCAutocompleteAudienceProps
 * validation props: required
 * @returns JSX.Element
 * @deprecated use JRCInputAutocomplete and its variants instead
 */
const JRCFormAutocompleteAudienceField = (props: JRCAutocompleteAudienceProps) => {
    return (
        <JRCFormSelectTagField
            getOptionValue={(v: any) => v.uri}
            getOptionLabel={(v: any) => v.name || v.title}
            asyncPromise={props.onlyUser ? autocompleteUser : autocompleteAudience}
            {...props}
        />
    );
};

export { JRCFormAutocompleteAudienceField };
